const Post13Summary = (lang) => {
	const isRom = lang === 'rom'

	
	return {
		lang,
		cardTitle: isRom?  'Strǎlucitoare - copilaria si adolescenta' :'Shining brightly - the early years',	
		cardText:  isRom ?  'Aceasta este povestea copilariei si adolescentei bunicii mei, Aurelia. Prin fotografiile ei vedem viata din anii interbelici, dintr-un sat în Argeș, crescând într-o familie prosperă dar lovită de pierderile din razboiul de intregire nationala, când toate erau noi de la fetele care poarta pantaloni la cercetase, sau liceu pedagogic.': 
		'This is the story of the early years of my grandmother, Aurelia and what the many photos of her tell us about growing up in the interwar years in a prosperous but war afflicted family in a southern county in Romania, when many things were new from wearing trousers to girl guides.', 
		photoPath: '/post13/collage13l.jpg', 
		photoPathShort: '/post13/collage13s.jpg', 
		linkId: 'brightly'
	}

}

export default Post13Summary;
